import React, { FC, useState } from 'react';
import css from './AiModal.module.css';
import { Icons } from '@Assets/SvgIcons';

type IProps = {
  placeholder: string;
  disabled?: boolean;
  onConversation: (e: string) => void;
};

const AiMessageInput: FC<IProps> = ({
  placeholder,
  disabled,
  onConversation,
}) => {
  const [messageText, setMessageText] = useState<string>('');
  const enterValue = () => {
    if (messageText !== '') {
      onConversation(messageText);
      setMessageText('');
    }
  };
  return (
    <div className={css.aiModalTabMessage} id="aiMessageInput">
      <div className={css.aiMessageInputContent}>
        <textarea
          className={[css.aiMessageInput, 'cstmTextarea'].join(' ')}
          placeholder={placeholder}
          onChange={e => setMessageText(e.target.value)}
          onFocus={e => (e.target.placeholder = '')}
          onBlur={e => (e.target.placeholder = placeholder)}
          value={messageText}
          disabled={disabled || false}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              enterValue();
            }
          }}
        />
        <div className={css.aiModalTabMessageFooter}>
          <div className={css.aiModalTabMessageCount}>
            {messageText.length} /4000
          </div>
          <button
            className={css.aiMessageSendBtn}
            disabled={disabled || false}
            onClick={() => {
              enterValue();
            }}
          >
            <Icons.Send />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiMessageInput;
